const e = {
  green: "#82c780",
  "green-dark": "#003d3b",
  "green-faint-dark": "#406E6C",
  "green-light": "#daeed9",
  "green-faint-light": "#76B79B",
  "green-success": "#39ce8f",
  "green-success-dark": "#90d3b7",
  "green-50": "#badcb9",
  "sand-light": "#f9f9f3",
  purple: "#d99ae2",
  "purple-dark": "#5a0b4d",
  "purple-light": "#e8bfef",
  "purple-extra-light": "#fce9ff",
  blue: "#4f5cd6",
  "blue-dark": "#150578",
  "blue-light": "#aec5f4",
  "blue-extra-light": "#e0e8fc",
  orange: "#c54801",
  "orange-dark": "#b64302",
  "orange-light": "#ffa392",
  pink: "#fe9ab8",
  "pink-dark": "#5a0b4d",
  "pink-light": "#fcc8d9",
  yellow: "#fde34d",
  "yellow-dark": "#fdbd24",
  "yellow-light": "#fff3c3",
  black: "#222222",
  "grey-400": "#6b6b6b",
  "grey-300": "#cbcbcb",
  "grey-200": "#e2e2e2",
  "grey-100": "#f6f6f6",
  white: "#fcfcfc",
  "red-error": "#ae0b0b",
  "blue-info": "#414CB4",
  "yellow-warning": "#ffc400",
  "btn-primary-secondary-hover": "#a55999",
  "btn-tertiary-hover": "#f7ebf9",
  "btn-alternative-hover": "#ebd4ef",
  transparent: "transparent",
  brown: "#4a170a"
}, r = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  xxl: "1400px"
}, a = {
  xs: "0.75rem",
  sm: "0.875rem",
  base: "1rem",
  regular: "1.125rem",
  md: "1.5rem",
  lg: "2rem",
  xl: "2.5rem",
  xxl: "3rem",
  xxxl: "4rem",
  xxxxl: "5rem",
  xxxxxl: "6rem",
  xxxxxxl: "7rem",
  xxxxxxxl: "8rem"
}, l = {
  colors: e,
  breakpoints: r,
  fontSize: a
};
export {
  r as breakpoints,
  e as colors,
  l as default,
  a as fontSize
};
